import { useContext, useEffect } from 'react';
import { useSwipeable } from 'react-swipeable';
import WordCard from './WordCard';
import WordlistContext, { EnrichedWord } from './_contexts/WordlistContext';

export default function WordlistPreview({ words }: { words?: EnrichedWord[] }) {
  const {
    selectedWord,
    favoriteIds: favorites,
    switched,
    toggleFavoriteWord,
    showPreviousWord,
    showNextWord,
  } = useContext(WordlistContext);

  const handlers = useSwipeable({
    onSwipedLeft: () => {
      if (!words) return;
      showNextWord(words);
    },
    onSwipedRight: () => {
      if (!words) return;
      showPreviousWord(words);
    },
  });

  useEffect(() => {
    const arrowKeysListener = (e: KeyboardEvent) => {
      if (!words) return;

      if (e.key === 'ArrowLeft') {
        return showPreviousWord(words);
      }
      if (e.key === 'ArrowRight') {
        return showNextWord(words);
      }
    };

    document.addEventListener('keydown', arrowKeysListener);

    return () => {
      document.removeEventListener('keydown', arrowKeysListener);
    };
  }, [showNextWord, showPreviousWord, words]);

  if (!selectedWord || !words) return null;

  const selectedWordIndex = words.findIndex(word => word.id === selectedWord.id);
  const canShowPreviousWord = selectedWordIndex > 0;
  const canshowNextWord = selectedWordIndex < words.length - 1;

  return (
    <div {...handlers} className="wordlist__preview" data-testid="wordlist-preview">
      <button
        className="wordlist__nav-btn"
        onClick={() => showPreviousWord(words)}
        disabled={!canShowPreviousWord}
        data-testid="wordlist__nav-btn--prev"
      >
        <svg className="icon">
          <use href="#icon-arrow-left" />
        </svg>
      </button>
      <WordCard
        word={selectedWord}
        isFavorite={favorites.includes(selectedWord.id)}
        onFavorite={() => toggleFavoriteWord(selectedWord.id)}
        flipped={switched}
      />
      <button
        className="wordlist__nav-btn"
        onClick={() => showNextWord(words)}
        disabled={!canshowNextWord}
        data-testid="wordlist__nav-btn--next"
      >
        <svg className="icon">
          <use href="#icon-arrow-right" />
        </svg>
      </button>
    </div>
  );
}
